import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", { class: "current" }, "Quotation", -1)
const _hoisted_4 = { class: "heading-div" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Quotation Listing", -1)
const _hoisted_6 = { class: "sort-div" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Sort By:", -1)
const _hoisted_8 = { class: "btn-group" }
const _hoisted_9 = {
  type: "button",
  class: "dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = {
  class: "dropdown-menu",
  style: {"cursor":"pointer"}
}
const _hoisted_11 = { class: "container-xxl" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_14 = { class: "card narrow-padding" }
const _hoisted_15 = { class: "table-responsive text-nowrap" }
const _hoisted_16 = { class: "table table-sm" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "centered" }, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Insured Details"),
    /*#__PURE__*/_createElementVNode("th", { class: "centered" }, "Coverage Period"),
    /*#__PURE__*/_createElementVNode("th", { class: "centered" }, "Sum insured"),
    /*#__PURE__*/_createElementVNode("th", { class: "centered" })
  ])
], -1)
const _hoisted_18 = { class: "table-border-bottom-0" }
const _hoisted_19 = { class: "centered" }
const _hoisted_20 = { class: "details" }
const _hoisted_21 = { class: "user" }
const _hoisted_22 = { class: "vehicle" }
const _hoisted_23 = { class: "centered" }
const _hoisted_24 = { class: "centered" }
const _hoisted_25 = { class: "centered" }
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "arrow-right" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, [
  /*#__PURE__*/_createElementVNode("label", null, "No Record Found ")
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "row table-bottom" }
const _hoisted_33 = { class: "col-sm-12 col-md-6" }
const _hoisted_34 = {
  class: "dataTables_info",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_35 = { class: "col-sm-12 col-md-6 dataTables_pager" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_paginate = _resolveComponent("paginate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'Dashboard' } }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.order_by == "DESC" ? "Newest to Oldest" : "Oldest to Newest"), 1)
          ]),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getPurchaseHistoryList(_ctx.currentPage,'DESC')))
              }, "Newest to Oldest ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPurchaseHistoryList(_ctx.currentPage,'ASC')))
              }, "Older to Newest")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotations, (quotation, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: quotation.id
                    }, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.fromItems + index), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "#" + _toDisplayString(quotation.id), 1)
                        ]),
                        _createElementVNode("ul", _hoisted_20, [
                          _createElementVNode("li", _hoisted_21, _toDisplayString(quotation.customer_name), 1),
                          _createElementVNode("li", _hoisted_22, _toDisplayString(quotation.vehicle_reg_no), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.formatDatePeriod(quotation.sum_insured_from)) + " - " + _toDisplayString(_ctx.formatDatePeriod(quotation.sum_insured_to)), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(quotation.cover_type != '3rd Party' ? 
                        quotation.sum_insured_price_from != quotation.sum_insured_price_to ? 
                      'RM ' + _ctx.convertTo2Decimal(quotation.sum_insured_price_from) + ' - RM ' + _ctx.convertTo2Decimal(quotation.sum_insured_price_to) 
                      : 'RM' + _ctx.convertTo2Decimal(quotation.sum_insured_price_from) 
                      : '-'), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("a", {
                          href: quotation.link_to_quotation,
                          target: "_blank"
                        }, _hoisted_28, 8, _hoisted_26)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.totalItems == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _hoisted_31))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, " Showing " + _toDisplayString(_ctx.fromItems) + " to " + _toDisplayString(_ctx.toItems) + " of " + _toDisplayString(_ctx.totalItems) + " results ", 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_paginate, {
                "page-count": _ctx.totalPage,
                "click-handler": _ctx.changePage,
                "prev-text": '<i class=arrow arrow-left></i>',
                "prev-class": 'paginate_button page-item previous cursor-pointer',
                "prev-link-class": 'page-link',
                "next-text": "<i class='arrow arrow-right'></i>",
                "next-class": 'paginate_button page-item next cursor-pointer',
                "next-link-class": 'page-link',
                "container-class": 'pagination',
                "page-class": 'paginate_button cursor-pointer',
                "page-link-class": 'page-link'
              }, null, 8, ["page-count", "click-handler"])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_36
  ]))
}